import React from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import styles from './ProfileBreadcrumbs.module.scss'

// breadcrumbs 
export default function ProfileBreadcrumbs({ items, rightContent }) {
  const { t } = useTranslation()

  return (
    <nav className={styles.wrapper} aria-label="Breadcrumb">
      <div className={styles.inner}>
        <ol className={styles.breadcrumbs}>
          {Array.isArray(items) && items.length > 0 ? (
            items.map((item, i) => (
              <li key={i} className={styles.item}>
                {item.href ? (
                  <a href={item.href} className={styles.link}>
                    {item.label}
                  </a>
                ) : (
                  <span className={styles.current}>{item.label}</span>
                )}
                {i < items.length - 1 && <span className={styles.sep}> &gt; </span>}
              </li>
            ))
          ) : (
            <li className={styles.item}>
              <span className={styles.current}>
                {t('profiles.youAreHere', 'You are here')}: {t('profiles.profile', 'Profile')}
              </span>
            </li>
          )}
        </ol>
        {rightContent && <div className={styles.right}>{rightContent}</div>}
      </div>
    </nav>
  )
}

ProfileBreadcrumbs.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      href: PropTypes.string,
    })
  ),
  rightContent: PropTypes.node,
}
